import React from 'react';
import PropTypes from 'prop-types';
import './PageTabs.css';

/**
 * PageTabs - Component for page-level tab navigation
 * @param {Array} tabs - Array of tab objects with { id, label, count }
 * @param {string} activeTab - Currently active tab ID
 * @param {function} onTabChange - Callback when tab is clicked
 */
function PageTabs({ tabs, activeTab, onTabChange }) {
  return (
    <div className="page-tabs">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          className={`page-tab ${activeTab === tab.id ? 'page-tab-active' : ''}`}
          onClick={() => onTabChange(tab.id)}
        >
          <span className="page-tab-label">{tab.label}</span>
          {tab.count !== undefined && (
            <span className="page-tab-count">{tab.count}</span>
          )}
        </button>
      ))}
    </div>
  );
}

PageTabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      count: PropTypes.number
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onTabChange: PropTypes.func.isRequired
};

export default PageTabs;

